import { Component } from "@angular/core";
import { ClientsListingComponent } from "./components/clients-listing/clients-listing.component";

@Component({
  selector: "jni-clients",
  templateUrl: "./clients.component.html",
  imports: [ClientsListingComponent],
  styleUrls: ["./clients.component.scss"],
})
export class ClientsComponent {}
